import { render, staticRenderFns } from "./ShareAccessHis.vue?vue&type=template&id=63880f0c&"
import script from "./ShareAccessHis.vue?vue&type=script&lang=js&"
export * from "./ShareAccessHis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports